'use strict';

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

module.exports = require('./is-implemented')() ? Symbol : require('./polyfill');